const stripPTags = (html: string) => {
  return html.replace(/<p>(.*?)<\/p>/g, "$1");
};

export default stripPTags;
